module.exports = __webpack_public_path__ + "8076be10a29152e7fcb2b5f21ff4fe8a.svg";